import React, { useEffect, useState } from 'react';
import LoadingSpinner from './LoadingSpinner';

export const WIZARD_SPINNER_DELAY_MS = 400;

export function useDelayedBusy(busy, delayMs = WIZARD_SPINNER_DELAY_MS) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!busy) {
      setShow(false);
      return undefined;
    }
    const timer = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [busy, delayMs]);
  return show;
}

export default function WizardStepReady({ ready, children }) {
  const showSpinner = useDelayedBusy(!ready);
  if (ready) return children;
  if (!showSpinner) {
    return <div className="wizard-step-placeholder" aria-busy="true" />;
  }
  return <LoadingSpinner />;
}
